import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5rem;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6rem;
    margin-bottom: 1rem;
    display: flex;

    .item-aba {
      border-radius: 0.5rem;
      padding: 0.3rem 0.8rem 0.3rem 0.5rem;
      background: ${Colors.Color2};
      margin-right: 0.6rem;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        content: '';
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        background: ${Colors.Color4};
        margin-right: 0.5rem;
        margin-left: 0.2rem;
        border-radius: 0.15rem;
      }

      p {
        font-size: 0.8125rem;
        font-weight: 800;
        color: ${Colors.Color7};
      }
    }

    .item-aba.ativo {
      background: ${Colors.Color4} !important;

      span {
        background: ${Colors.Color9} !important;
      }

      p {
        color: ${Colors.Color9} !important;
      }
    }

    .h-descricao {
      font-size: 0.7125rem;
      line-height: 0.8rem;
      color: ${Colors.Color7};
    }
  }

  .item-modal {
    display: none;
  }

  .item-modal.ativo {
    width: 100%;
    height: 100%;
    display: block;
  }

  .footer {
    position: fixed;
    bottom: 3rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2.4rem;

    @media (max-height: 768px) {
      bottom: 1rem;
    }
  }

  .lista-calculo {
    .text-h {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem !important;

      input {
        width: 16rem;
      }
    }
  }
`;

export const DistribuicaoEHorasContainer = styled.div`
  /* padding-inline: 16px; */
  margin-top: 24px;

  p,
  span,
  div {
    color: ${Colors.Color7};
  }

  .Label_title_p {
    font-size: 0.9rem;
    font-weight: 400;
  }
`;

export const CardContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* align-items: center;
  justify-content: space-between; */
  padding: 16px;
  /* background: rgba(255, 255, 255, 0.05); */
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  transition: all 0.3s ease;

  width: 100%;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  p,
  span,
  div {
    color: ${Colors.Color7};
  }

  .Label_title_p {
    font-size: 0.9rem;
    font-weight: 400;
  }
`;

export const FinanceResultContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;

  display: flex;
  padding: 16px;
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  transition: all 0.3s ease;

  width: 100%;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  p,
  span,
  div {
    color: ${Colors.Color7};
  }

  .Label_title_p {
    font-size: 0.9rem;
    font-weight: 400;
  }

  p {
    font-size: 0.875rem;
    font-weight: 500;
    color: ${Colors.Color7};
  }

  span {
    font-size: 1em;
    font-weight: 700;
    color: ${Colors.Color9};
  }
`;

export const AnalistasTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.bgCardColor};
  border-radius: 12px;
  text-align: center;
  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  margin-top: 16px;
`;

export const AnalistasTableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  width: 100%;
  padding: 24px;
  gap: 16px;
  background-color: #6796cf;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 500;
  line-height: 24px;
`;

export const AnalistasTableBody = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  align-items: center;
  width: 100%;
  padding: 24px;
  gap: 16px;
  font-size: 16px;
  color: ${Colors.text_Color_1};
  font-weight: 300;
  line-height: 24px;
  border-bottom: 1px solid
    ${props => (props.hasBorder ? `${Colors.Border_Color_1}` : 'transparent')};

  &:last-child {
    border-bottom: none;
  }
`;
